import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import type { SelectChangeEvent } from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import type { ReportFile } from "@/api/report/_models/Report";
import { LATEST } from "@/api/report/_models/Report";

interface ReportSelectorProps {
  id: string;
  files: ReportFile[] | null;
  value: string;
  onChange: (name: string) => void;
}

/** Header dropdown for a report page: "Latest" plus one entry per file; the selection picks the report loaded. */
export const ReportSelector = (props: ReportSelectorProps) => {
  const { id, files, value, onChange } = props;

  const handleChange = (e: SelectChangeEvent) => {
    onChange(e.target.value);
  };

  return (
    <FormControl
      size="small"
      sx={{ minWidth: 320 }}
    >
      <InputLabel id={`${id}-label`}>Report</InputLabel>
      <Select
        labelId={`${id}-label`}
        label="Report"
        value={value}
        onChange={handleChange}
      >
        <MenuItem value={LATEST}>Latest</MenuItem>
        {files?.map((file) => (
          <MenuItem
            key={file.name}
            value={file.name}
          >
            {file.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
